<aside class="esf-main-sidebar esf-main-sidebar--working-space -has-transition"
       [ngClass]="{'-is-open': clubOverviewService.listOfModals.editLogoModal}">
  <div class="esf-main-sidebar__content">
    <h3 i18n="Club logo upload heading@@clubComponent.heading.uploadLogo">Upload logo</h3>
    <form (ngSubmit)="uploadLogo()" id="uploadLogoForm">
      <div app-form-field-image-upload
           [control]="clubForm.get('logo')">
      </div>
    </form>
  </div>
</aside>

<div class="esf-main-sidebar--working-space__actions -has-transition"
     [ngClass]="{'-is-open': clubOverviewService.listOfModals.editLogoModal}">
  <div class="esf-submit-row">
    <div class="esf-submit-row__item">
      <button *ngIf="!clubOverviewService.updateLoading"
              form="uploadLogoForm"
              i18n="General submit button@@general.button.submit"
              [disabled]="!imageUpload?.isValidFileType && clubOverviewService.listOfModals.editLogoModal"
              class="esf-button esf-button--standard esf-button--filled">Submit
      </button>
      <div *ngIf="clubOverviewService.updateLoading" class="esf-spinner flex-container">
        <div class="row">
          <span class="esf-spinner__bounce esf-spinner__bounce--1"></span>
          <span class="esf-spinner__bounce esf-spinner__bounce--2"></span>
          <span class="esf-spinner__bounce esf-spinner__bounce--3"></span>
        </div>
      </div>
    </div>
    <div class="esf-submit-row__item">
      <button class="esf-button esf-button--standard esf-button--outlined"
              i18n="General back button@@general.button.back"
              (click)="clubOverviewService.toggleAllModal(false)">Back
      </button>
    </div>
  </div>
</div>

<div class="esf-hamburger esf-hamburger--working-space -has-transition"
     [ngClass]="{'-is-open': clubOverviewService.listOfModals.editLogoModal }" (click)="clubOverviewService.toggleAllModal(false)">
  <span class="esf-hamburger__icon"></span>
</div>
